import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import de from './locales/de.json';
import en from './locales/en.json';

i18next.use(initReactI18next).init({
    lng: 'de',
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
    },
    resources: {
        de: { translation: de },
        en: { translation: en },
    },
});

export default i18next;
